<fieldset class="border-navyBlue" style="height: 331px">
  <!--document type name-->
  <legend class="bg-primary">
    {{ documentTypes[counter]?.key | enumToText : documentTypes }}
  </legend>

  <div class="row">
    <!--#region fields  -->

    <!--preview file-->
    <app-show-images
      *ngIf="imgUrl || (pdfUrl == null && imgUrl == null)"
      [src]="imgUrl"
    ></app-show-images>
    <app-pdf-reader *ngIf="pdfUrl" [src]="pdfUrl"></app-pdf-reader>

    <!--description-->
    <form-textarea
      class="tw-w-full tw-mt-3"
      [label]="fields + 'description'"
      [value]="modelItems[counter]?.description"
      (valueChange)="modelItems[counter].description = $event"
      [control]="form?.get('voiceText')"
      [rows]="2"
    >
    </form-textarea>

    <!--DocumentStatus-->
    <div
      class="md:tw-w-2/3"
      *ngIf="(imgUrl != null || pdfUrl != null) && currentId != selectedId"
    >
      <enum-select-search
        class="tw-w-full"
        enumName="DocumentStatus"
        [label]="fields + 'documentStatus'"
        [(value)]="modelItems[counter].status"
        (onError)="onClose()"
      >
      </enum-select-search>
    </div>

    <!--#endregion -->

    <!--changeStatus Btn-->
    <div class="md:tw-w-1/3 align-self-center tw-flex-center">
      <a
        *ngIf="(imgUrl != null || pdfUrl != null) && currentId != selectedId"
        (click)="changeStatus(modelItems[counter])"
        matSuffix
        class="btn tw-w-full"
        [themeColor]="'btn-info'"
      >
        <span class="tw-font-bold">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
          {{ "common.submit" | translate }}
        </span>
      </a>
    </div>
  </div>
</fieldset>
